import script from "./HeroParticles.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroParticles.vue?vue&type=script&setup=true&lang=js"

import "./HeroParticles.vue?vue&type=style&index=0&id=779a7a7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-779a7a7c"]])

export default __exports__